export default theme => ({

    root: {
        width: 350,

        
        "& > * + *": {
          marginTop: theme.spacing(2)
        }
      },
    tag:1,style:{
      "& .MuiChip-label": {
        color: "blue"
      },
    },
    tag0:{
      "& .MuiChip-label": {
        color: "red"
      },
    },
    tag:2,style:{
      "& .MuiChip-label": {
        color: "yellow"
      },
    },
    tag:3,style:{
      "& .MuiChip-label": {
        color: "green"
      },
    },
    
    /*  tag: {
        //backgroundColor: "#a0a",
        //height: 24,
        //position: "relative",
        //zIndex: 0,
        "& .MuiChip-label": {
          color: "green"
        },
        "& .MuiChip-deleteIcon": {
          color: "red"
        },
      },
    */
  });
  
  


// WEBPACK FOOTER //
// ./src/helpers/Filter/styles.jsx